import {
  IAssetDTO,
  ICriteriaDTO,
  ICriteriaGroupDTO,
  IPaginationDTO,
  ITeamCriteriaSelectionDTO,
  ITeamLevelDTO,
} from '@/dtos';
import { generatePagination, get, post, remove, UploadResponse, uploadS3 } from '../apiWrapper';

export const createCriteriaAPI = async (
  yearId: string,
  criteria: ICriteriaDTO,
): Promise<ICriteriaDTO> => {
  const ret = await post<ICriteriaDTO>(`/admin/years/${yearId}/createCriteria`, criteria);
  return ret;
};

export const updateCriteriaAPI = async (criteria: ICriteriaDTO): Promise<ICriteriaDTO> => {
  const ret = await post<ICriteriaDTO>(`/admin/years/criteria/save`, criteria);

  return ret;
};

export const getCriteriaGroupsForYearAPI = async (
  yearId: string,
  pagination: IPaginationDTO,
): Promise<{ data: ICriteriaGroupDTO[]; count: number }> => {
  const pageOptions = await generatePagination(pagination);
  const criteraGroups = await get<{ data: ICriteriaGroupDTO[]; count: number }>(
    `/admin/years/${yearId}/criteriagroups${pageOptions}`,
  );
  return criteraGroups;
};

export const createCriteriaGroupAPI = async (
  yearId: string,
  data: ICriteriaGroupDTO,
): Promise<ICriteriaGroupDTO> => {
  const criteriaGroup = await post<ICriteriaGroupDTO>(
    `/admin/years/${yearId}/createCriteriaGroup`,
    data,
  );
  return criteriaGroup;
};

export const updateCriteriaGroupAPI = async (
  criteriaGroup: ICriteriaGroupDTO,
): Promise<ICriteriaGroupDTO> => {
  const ret = await post<ICriteriaGroupDTO>(`/admin/years/criteriaGroup/save`, criteriaGroup);

  return ret;
};
export const removeCriteriaGroupAPI = async (criteriaGroupId: string): Promise<boolean> => {
  const ret = await remove<boolean>(`/admin/years/criteriaGroup/${criteriaGroupId}`);

  return ret;
};

export const removeCriteriaAPI = async (criteriaID: string): Promise<boolean> => {
  const criteria = await remove<boolean>(`/admin/years/criteria/${criteriaID}`);
  return criteria;
};

export const uploadCriteriaGroupAssetAPI = async (
  criteriaGroupId: string,
  file: File,
  onProgress: (percentComplete: number) => void,
): Promise<IAssetDTO> => {
  const body = {
    fileName: file.name,
    fileSize: file.size,
  };
  const response = await post<UploadResponse>(
    `/admin/years/criteriaGroup/${criteriaGroupId}/uploadAsset`,
    body,
  );

  const { url, assetId } = response;

  const returnObj = await uploadS3(url, file, assetId, onProgress);

  return returnObj;
};

export const uploadCriteriaThubmnailAPI = async (
  criteriaGroupId: string,
  file: File,
  onProgress: (percentComplete: number) => void,
): Promise<IAssetDTO> => {
  const body = {
    fileName: file.name,
    fileSize: file.size,
  };
  const response = await post<UploadResponse>(
    `/admin/years/criteria/${criteriaGroupId}/uploadAsset`,
    body,
  );

  const { url, assetId } = response;

  const returnObj = await uploadS3(url, file, assetId, onProgress);

  return returnObj;
};

export const uploadCriteriaMovieAPI = async (
  criteriaGroupId: string,
  file: File,
  onProgress: (percentComplete: number) => void,
): Promise<IAssetDTO> => {
  const body = {
    fileName: file.name,
    fileSize: file.size,
  };
  const response = await post<UploadResponse>(
    `/admin/years/criteria/${criteriaGroupId}/uploadVideoAsset`,
    body,
  );

  const { url, assetId } = response;

  const returnObj = await uploadS3(url, file, assetId, onProgress);

  return returnObj;
};

export const getTeamsCriteriaAPI = async (
  yearId: string,
  teamId: string,
): Promise<{ data: ITeamCriteriaSelectionDTO[]; count: number }> => {
  const critera = await get<{ data: ITeamCriteriaSelectionDTO[]; count: number }>(
    `/admin/years/${yearId}/teams/${teamId}/criteria`,
  );
  return critera;
};

export const getNextCriteriaNumberAPI = async (yearId: string): Promise<number> => {
  const teams = await get<number>(`admin/years/${yearId}/nextCriteriaNumber`);
  return teams;
};

export const assignTeamsCriteriaAdminAPI = async (
  yearId: string,
  teamId: string,
  selectedCriteria: ITeamCriteriaSelectionDTO[],
): Promise<boolean> => {
  const results = await post<boolean>(
    `/admin/years/${yearId}/teams/${teamId}/criteria`,
    selectedCriteria,
  );
  return results;
};

export const getCriteriaCountForTeamLevelsAPI = async (
  yearId: string,
): Promise<{ data: ITeamLevelDTO[]; count: number }> => {
  const results = await get<{ data: ITeamLevelDTO[]; count: number }>(
    `/admin/years/${yearId}/criteria-teams`,
  );
  return results;
};

export const saveCriteriaCountForTeamLevelsAPI = async (
  yearId: string,
  team_levels: ITeamLevelDTO[],
): Promise<boolean> => {
  const results = await post<boolean>(`/admin/years/${yearId}/criteria-teams`, team_levels);
  return results;
};

export const updateCriteriaGroupsAPI = async (
  yearId: string,
  groups: ICriteriaGroupDTO[],
): Promise<boolean> => {
  const results = await post<boolean>(`/admin/years/${yearId}/criteria-groups`, groups);
  return results;
};
